import createCollectionStore from '../create';
import { getProductInstanceAvailableUpdate } from '../../update-service';

export default createCollectionStore(
  'ProductVersions',
  () => getProductInstanceAvailableUpdate(),
  '',
  {},
  {
    // Kill these functions so they don't do anything
    updateCache: () => ({}),
    removeCache: () => ({})
  }
);


// WEBPACK FOOTER //
// ./src/services/collection/collections/product-versions.js